export default Object.freeze({
  EstudianteLugarHora: 1,
  HermanosLugarHora: 2,
});
